export default __webpack_public_path__ + "static/media/carlig_logo.dc4d5458.svg";